import type { DebugConfig } from '@modules/debug_config';
import { storage } from '@visiba/std';

export const devLocalStorage = storage<{
	config: DebugConfig.LocalStorageConfig;
	overrideFlags: Record<keyof ExpectedFlags, boolean> | null;
}>();
